<template>
  <div class="z-service-normal-detail">
    <div>
      <div
        class="z-total-container d-flex align-items-center justify-content-between font-weight-semi-bold"
      >
        <div class="h5 font-weight-bold">
          Total
        </div>
        <div>{{ totalFormatted }} {{ currency }}</div>
      </div>
    </div>
    <b-list-group flush class="border-top mt-3">
      <b-list-group-item v-if="haveAdditionalHours">
        Cargo por tiempo extra
        <div>{{ getAdditionalHoursCost }}</div>
      </b-list-group-item>
      <b-list-group-item>
        {{ messageForSubtotal }}
        <div>{{ subtTotalFormatted }}</div>
      </b-list-group-item>
      <b-list-group-item>
        {{ $t("tax") }} (16%)
        <div>{{ taxFormatted }}</div>
      </b-list-group-item>
      <slot name="custom-items"></slot>
    </b-list-group>
  </div>
</template>

<script>
import { formatMoney } from "@/utils/money";
import { minutesToHours } from "@zubut/common/src/utils/time";
import serviceRate from "@/mixins/serviceRate";
import ServiceStatus from "@/constants/services/status";
import AdditionalHours from "@zubut/common/src/constants/services/additional-hours";

export default {
  name: "MultiPointServicePaymentDetail",

  mixins: [serviceRate],

  props: {
    isAccountUser: {
      type: Boolean,
      default: false
    },
    isConsolidatedUser: {
      type: Boolean,
      default: false
    },
    service: {
      type: Object,
      required: true
    },
    serviceBrand: {
      type: String,
      default: ""
    },
    serviceCard: {
      type: String,
      default: ""
    },
    serviceWalletId: {
      type: String,
      default: ""
    },
    serviceTime: {
      type: Number,
      default: 0
    },
    currency: {
      type: String,
      default: "MXN"
    }
  },

  computed: {
    canceledService() {
      return ServiceStatus.CANCELLED_STATUS.includes(this.service.status);
    },

    chargeForService() {
      return this.shouldChargeForCanceledService(this.service);
    },

    messageForSubtotal() {
      if (this.canceledService) {
        return this.chargeForService
          ? "Comisión por servicio cancelado"
          : "Servicio cancelado";
      }
      return "Subtotal";
    },

    destinations() {
      if (this.service.destinations) {
        return this.service.destinations;
      }
      return [];
    },

    isOld() {
      if (this.service.vehicleType === undefined) {
        return true;
      }
      return false;
    },

    kms() {
      if (!this.noChargeForCanceledService) {
        return this.service.km;
      }
      return 0;
    },

    showCreditCardTemination() {
      if (
        this.serviceBrand !== null &&
        this.serviceBrand !== "none" &&
        !(
          this.service.status === ServiceStatus.NUM_DRIVER_CANCELLED ||
          this.noChargeForCanceledService
        ) &&
        !this.isAccountUser
      ) {
        return true;
      }
      return false;
    },

    time() {
      const time = Math.round(this.serviceTime);
      if (time > 60) {
        return `${minutesToHours(time)} hrs`;
      }
      return `${time} min`;
    },

    total() {
      return this.service?.paymentDetails?.total ?? null;
    },

    totalFormatted() {
      if (this.total !== null) {
        return formatMoney(this.total).replace(/.00$/, "");
      }
      return "";
    },

    subtotal() {
      return this.service?.paymentDetails?.subtotal ?? null;
    },

    subtTotalFormatted() {
      if (this.subtotal !== null) {
        return formatMoney(this.subtotal);
      }
      return "";
    },

    tax() {
      return this.service?.paymentDetails?.tax ?? null;
    },

    taxFormatted() {
      if (this.subtotal !== null) {
        return formatMoney(this.tax);
      }
      return "";
    },

    hasFixedRate() {
      return false;
    },

    haveAdditionalHours() {
      return (
        this.service.additionalHoursRequest &&
        this.service.additionalHoursRequest.status ===
          AdditionalHours.NUM_ACCEPTED_HOURS
      );
    },

    getAdditionalHoursCost() {
      return (
        formatMoney(this.service.additionalHoursRequest.additionalCost) || null
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.z-service-normal-detail {
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  flex-direction: column;
  font-size: 12px;

  .z-total-container {
    div:last-child {
      font-size: 20px;
    }
  }

  .list-group-item {
    display: flex;
    justify-content: space-between;
    padding: 0.75rem 0;
  }

  .resume-data {
    color: $dim-gray;
  }
}
</style>
